import {useFactoryFetch} from "@/composables/useFactoryFetch.ts";
import {API_URLS} from "@/utils/constants/api-urls.ts";
import {AfterFetchContext, MaybeRefOrGetter, UseFetchOptions} from "@vueuse/core";
import {ICreateGroupRequest, IGetResult, IGroup, IUser, QueryFilter} from "@/types/api.ts";
import {useAxios} from "@vueuse/integrations/useAxios";
import {axiosInstance} from "@/composables/axiosInstance.ts";
import {computed, toValue} from "vue";

export class GroupService {

  static getInstance(): GroupService {
    return new GroupService();
  }

  async createGroup(body: ICreateGroupRequest): Promise<void> {
    const {execute} = useAxios<IGetResult>(API_URLS.groups.create, {
      method: "POST",
      data: body
    }, axiosInstance, {immediate: false})
    await execute();
  }

  getGroups(query?: MaybeRefOrGetter<QueryFilter<IGroup>>, options?: UseFetchOptions) {
    const url = computed<string>(() => {
      let s = API_URLS.groups.list(toValue(query));
      return s
    });
    return useFactoryFetch(url, {
      afterFetch(ctx: AfterFetchContext) {
        return {data: ctx?.data?.data}
      },
      ...options
    }).json<IGroup[]>();
  }

  getCurrentStudentPayments() {
    return useFactoryFetch(API_URLS.payments.getCurrentStudentPayments, {
      afterFetch(ctx: AfterFetchContext) {
        return {data: ctx?.data?.studentPayments}
      }
    }).json();
  }

  async getStudentPayments(studentId: string) {
    const {execute, data} = useAxios<IGetResult>(API_URLS.payments.getStudentPayments(studentId), {
      method: "get"
    }, axiosInstance, {immediate: false})
    await execute();
    return data.value?.data?.studentPayments;
  }

  async deleteGroup(group: IGroup) {
    const {execute} = useAxios<IGetResult>(API_URLS.groups.deleteById(group._id), {
      method: "DELETE",
    }, axiosInstance, {immediate: false})
    await execute();
  }

  async joinStudents(students: IUser[], group: IGroup) {
    const {execute, data} = useAxios<IGetResult>(API_URLS.groups.joinStudents(group._id), {
      method: "PATCH",
      data: {students: students.map(s => s._id)}
    }, axiosInstance, {immediate: false})
    await execute();
    return data?.value?.data?.data;
  }
}